import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { initializeBounceAnimation } from "@/core/utils/bounceAnimation";
const BounceCardSection = () => {
    useEffect(() => {
        initializeBounceAnimation();
    }, []);
    const cardImages = [
        "/images/gallery/andrew-sample-nothern-virginia-foodies-photo-1.jpg",
        "/images/gallery/andrew-sample-nothern-virginia-foodies-photo-2.jpg",
        "/images/gallery/andrew-sample-nothern-virginia-foodies-photo-3.jpg",
        "/images/gallery/andrew-sample-nothern-virginia-foodies-photo-4.jpg",
    ];
    return (_jsx("div", { className: "max-w-4xl mx-auto ", children: _jsx("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2 ", children: cardImages.map((image, index) => (_jsx("div", { className: `p-4 bg-white rounded-lg shadow-md bounce-card-wrapper bounce-card-${index + 1}`, style: {
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "200px",
                } }, index))) }) }));
};
export default BounceCardSection;
